import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

const Label = React.forwardRef(({ 
  className, 
  required = false,
  ...props 
}, ref) => {
  const { theme } = useTheme();
  
  return (
    <label
      ref={ref}
      className={cn(
        `block text-sm font-semibold ${theme.text.primary} mb-2`,
        className
      )}
      {...props}
    >
      {props.children}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
  );
});

Label.displayName = "Label";

export { Label };
